<template>
    <div v-if="open" class="fixed z-30 bottom-0 left-0 right-0 backdrop-blur-md backdrop-brightness-75 flex flex-col justify-center items-center min-h-screen">
        <div @click.stop="" class="p-8 top-[80px] mx-auto bg-white rounded-md shadow-md relative min-h-[100px] max-h-[70vh] overflow-y-auto w-3/4 md:w-1/2 lg:w-1/3">
            <div class="py-4 border-b border-gray-300 w-full">
                <strong>
                    {{ $t('Please verify your Address') }}
                </strong>
            </div>
            <div class="mt-4">
                <div class="py-4">
                    <div @click="activeAddress = 'userAddress'" class="bg-white flex flex-row items-center gap-4 p-2 rounded-md shadow-md cursor-pointer">
                        <div class="flex items-center justify-center cursor-pointer ml-2">
                            <div class="w-4 h-4 rounded-full border border-blue" :class="activeAddress === 'userAddress' ? 'bg-blue' : ''" />
                        </div>

                        <div class="p-2 w-full">
                            <small class="text-xxs">
                                {{ $t('Your Address') }}
                            </small>

                            <p>
                                {{ userAddress.street }}
                                <br />
                                {{ userAddress.location }}
                                <br />
                                {{ userAddress.zipcode }}
                                <br />
                                {{ userAddressCountry }}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="py-4">
                    <div @click="activeAddress = 'correctedAddress'" class="bg-white flex flex-row items-center gap-4 p-2 rounded-md shadow-md cursor-pointer">
                        <div class="flex items-center justify-center cursor-pointer ml-2">
                            <div class="w-4 h-4 rounded-full border border-blue" :class="activeAddress === 'correctedAddress' ? 'bg-blue' : ''" />
                        </div>

                        <div class="p-2 w-full">
                            <small class="text-xxs">
                                {{ $t('Or did you mean') }}
                            </small>
                            <p>
                                {{ correctedAddress.street }}
                                <br />
                                {{ correctedAddress.location }}
                                <br />
                                {{ correctedAddress.zipcode }}
                                <br />
                                {{ correctedAddressCountry }}
                            </p>
                        </div>
                    </div>
                </div>

                <hr class="w-full border-gray-300 border-b-0.5 my-4" />

                <FormButton @click="confirm()" class="mt-3" styling="primary flex items-center gap-3 w-full justify-center" :value="$t('Choose Address')" :disabled="false">
                </FormButton>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        activeAddress: ''
    }),

    mounted() {},

    props: ['open', 'userAddress', 'correctedAddress', 'countries'],

    methods: {
        confirm() {
            let address = {};

            if (this.activeAddress === 'userAddress') {
                address = this.userAddress;
            }
            if (this.activeAddress === 'correctedAddress') {
                address = this.correctedAddress;
            }

            this.$emit('confirm', address);
        }
    },

    computed: {
        userAddressCountry() {
            return this.countries.find((country) => {
                return country.id === this.userAddress.country_id;
            })?.name?.de;
        },
        correctedAddressCountry() {
            return this.countries.find((country) => {
                return country.id === this.correctedAddress.country_id;
            })?.name?.de;
        }
    }
};
</script>
